import { Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { StyledOpenAccidentCards } from "../../../../styled/accident";

const OpenAccidentCards = ({ accidents, handleView }) => {
  return accidents.map((accident) => (
    <StyledOpenAccidentCards.Card elevation={2} key={accident.siniestro}>
      <StyledOpenAccidentCards.CardLeftContainer>
        <Typography>
          <b>Nº Siniestro:</b> {accident.siniestro}
        </Typography>
        <Typography>
          <b>Fecha hora accidente:</b>{" "}
          {moment(accident.fechaHoraAccidente).format("DD/MM/YYYY HH:mm")}
        </Typography>
        <Typography>
          <b>Diagnóstico:</b> {accident.diagnosticoOMS} - {accident.diagnostico}
        </Typography>
        <Typography>
          <b>Empleador:</b> {accident.empleador} ({accident.empleadorCuit})
        </Typography>
        <Typography>
          <b>Referente:</b> {accident.referente}
        </Typography>
        <Typography>
          <b>Referente Email:</b> {accident.referenteEmail}
        </Typography>
      </StyledOpenAccidentCards.CardLeftContainer>
      <StyledOpenAccidentCards.CardRightContainer>
        <Tooltip title="Ver siniestro">
          <StyledOpenAccidentCards.CardIcon
            onClick={() => handleView(accident)}
          />
        </Tooltip>
      </StyledOpenAccidentCards.CardRightContainer>
    </StyledOpenAccidentCards.Card>
  ));
};

export default OpenAccidentCards;
